/* === BS Animations ===
   IntersectionObserver para animaciones de entrada al scroll.
   Centraliza la animacion de TODAS las sections bs-* — un solo observer
   para todas, no per-section. Pattern adoptado de SOKA (sk-animations.js).
*/
(function() {
  'use strict';

  /* Secciones above-the-fold del home — no se animan (visibles instant al cargar) */
  /* Above-fold por template:
       - home (template index): bs-header + bs-categories
       - resto (blog/page/etc): bs-header + bs-page-hero
     Skip las que arrancan visibles al cargar — sino opacity:0 retrasa el LCP. */
  var SKIP = ['bs-header', 'bs-categories', 'bs-page-hero'];

  /* Contenedores cuyos hijos se animan en stagger (cards en carousels, grids, accordions).
     Lista pre-definida — si la clase no existe en una section, .querySelector devuelve null
     y se ignora silenciosamente. Añadir nuevas clases segun crezca el proyecto. */
  var STAGGER = [
    '.bs-product-carousel__row',
    '.bs-products__grid',
    '.bs-banners__row',
    '.bs-banners__grid',
    '.bs-category-search__grid',
    '.bs-testimonials__slider',
    '.bs-testimonials__list',
    '.bs-experts__grid',
    '.bs-history__steps',
    '.bs-history__list',
    '.bs-blog-articles__grid',
    '.bs-blog-articles__list',
    '.bs-faq-help__list',
    '.bs-faq-help__accordion'
  ];

  function shouldSkip(el) {
    for (var i = 0; i < SKIP.length; i++) {
      if (el.classList.contains(SKIP[i])) return true;
    }
    return false;
  }

  function setup(el) {
    if (shouldSkip(el)) return null;
    el.classList.add('bs-animate');

    /* Si la section tiene algun container conocido con >1 hijo → marcar stagger */
    for (var i = 0; i < STAGGER.length; i++) {
      var c = el.querySelector(STAGGER[i]);
      if (c && c.children.length > 1) {
        c.classList.add('bs-stagger');
      }
    }
    return el;
  }

  function init() {
    var all = document.querySelectorAll('section[class*="bs-"]');
    var targets = [];

    for (var i = 0; i < all.length; i++) {
      var el = setup(all[i]);
      if (el) targets.push(el);
    }
    if (!targets.length) return;

    /* Fallback sin IntersectionObserver (browsers ancestrales) */
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('bs-animate--visible');
      }
      return;
    }

    /* Una sola IntersectionObserver para todas las sections.
       El observer triggea inmediatamente al mount para cualquier section ya intersectando
       (visible al cargar la pagina) — no hace falta cascade manual ni clasificacion previa.
       Para below-fold espera al scroll. Threshold 0.08 = 8% visible para activar. */
    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('bs-animate--visible');
          observer.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.08 });

    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Customizer: section recien cargada se muestra inmediato sin animacion stagger
     completa (el merchant quiere ver el resultado, no esperar a animaciones). */
  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('section[class*="bs-"]');
    if (s && !shouldSkip(s)) {
      setup(s);
      requestAnimationFrame(function() {
        s.classList.add('bs-animate--visible');
      });
    }
  });
})();
